import { Component } from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import { environment } from 'src/environments/environment';
import { PAGE_SIZE, MAX_SIZE } from 'src/app/onelog/common/config/common';
import { AUTHOR_BOOK_INFORMATION_URL } from 'src/app/onelog/common/config/url';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import {
  DROP_DOWN_AUTHOR_TYPE,
  DEFAULT_SELECTED_AUTHOR_TYPE,
  DROP_DOWN_NETSUITE_ID_TYPE,
  DEFAULT_NETSUITE_ID_TYPE,
} from 'src/app/onelog/common/config/dropdown-config';

@Component({
  selector: 'app-author-book-information',
  templateUrl: './author-book-information.component.html',
  styleUrls: ['./author-book-information.component.css'],
})
export class AuthorBookInformationComponent {
  products: any = [];
  pageSize: number = PAGE_SIZE;
  maxSize: number = MAX_SIZE;
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 0;
  dropdownSettingsBookType: IDropdownSettings = {};
  dropdownSettingsNetsuiteIdType: IDropdownSettings = {};
  dropdownListBookType: any = [];
  defaultAuthorList: any = [];
  netSuiteIDList: any = [];
  DefaultNetSuiteIDList: any = DEFAULT_NETSUITE_ID_TYPE;
  authorFilterArray: any = [];
  showSearchLoading: boolean = false;
  showDownloadLoading: boolean = false;
  searchBtnText: string = 'Search';
  downloadBtnText: string = 'Download';
  netsuiteFilterArray: any = [];

  constructor(private requestService: RequestService) {}

  ngOnInit() {
    this.dropdownListBookType = DROP_DOWN_AUTHOR_TYPE;
    this.authorFilterArray = DEFAULT_SELECTED_AUTHOR_TYPE;
    this.defaultAuthorList = DEFAULT_SELECTED_AUTHOR_TYPE;
    this.netSuiteIDList = DROP_DOWN_NETSUITE_ID_TYPE;
    this.netsuiteFilterArray = DEFAULT_NETSUITE_ID_TYPE;
    this.getData(AUTHOR_BOOK_INFORMATION_URL, this.createPostData());
  }

  getData(
    url: string = AUTHOR_BOOK_INFORMATION_URL,
    data: any = [],
    urlParams: string = ''
  ) {
    this.requestService
      .postRequest(url, data, urlParams)
      .subscribe((data: any) => {
        console.log(data);
        this.products = data.data;
        this.totalProducts = data.total;
        this.perPage = data.per_page;
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;
      });
  }

  // Update Current Page
  updatePageData(event: Event) {
    const eventData: any = event;
    console.log(eventData.currentPage);
    let urlParams = `?page=${eventData.currentPage}`;
    this.getData(AUTHOR_BOOK_INFORMATION_URL, this.createPostData(), urlParams);
  }

  //Create POST Data to send
  createPostData() {
    return {
      selectedAuthorType: this.authorFilterArray,
      selectedNetSuiteType: this.netsuiteFilterArray,
    };
  }

  // Update DropDown based on the type of dropdown selected
  updateSelectedDropDown(event: Event) {
    const eventData: any = event;

    if (event.type == 'authorType') {
      this.updateAuthorFilter(eventData);
    }

    if (eventData.type == 'netsuiteId') {
      this.updateNetsuiteFilter(eventData);
    }
  }

  //Download Report
  downloadReport() {
    this.requestService.download(
      AUTHOR_BOOK_INFORMATION_URL,
      {
        is_download: 1,
        selectedAuthorType: this.authorFilterArray,
        selectedNetSuiteType: this.netsuiteFilterArray,
      },
      '',
      'AUTHOR_BOOK_INFORMATION_URL'
    );
  }

  //Search Function
  search() {
    this.getData(AUTHOR_BOOK_INFORMATION_URL, this.createPostData());
  }

  updateAuthorFilter(eventData: any) {
    if (eventData.action == 'deSelected') {
      if (this.authorFilterArray.indexOf(eventData.action.item)) {
        this.authorFilterArray.splice(
          this.authorFilterArray.indexOf(eventData.action.item),
          1
        );
      }
    }

    if (eventData.action == 'selected') {
      this.authorFilterArray.push(eventData.item);
    }
  }

  updateNetsuiteFilter(eventData: any) {
    if (eventData.action == 'deSelected') {
      if (this.netsuiteFilterArray.indexOf(eventData.action.item)) {
        this.netsuiteFilterArray.splice(
          this.netsuiteFilterArray.indexOf(eventData.action.item),
          1
        );
      }
    }

    if (eventData.action == 'selected') {
      this.netsuiteFilterArray.push(eventData.item);
    }
  }
}
